import { type ContractMenuItem } from "./ContractMenu";

export const contractMenuItemFromId = (
  id: string,
  list: ContractMenuItem[] | undefined | null,
): ContractMenuItem | undefined => list?.find((item) => item.uuid === id);
